import React from 'react';
import ReactDOM from 'react-dom';
import { toJS } from 'mobx';
import { deserialize, serialize } from '../utils/serializr/serializr';
import Cookies from 'js-cookie';
import { runtime } from '../classes/runtime/Runtime';
import { xa } from '../utils/xa/xa';
window.React = React;
window.ReactDOM = ReactDOM;
// later: remove these things from global context!
window.Cookies = Cookies;
window.toJS = toJS;
window.serialize = serialize;
window.deserialize = deserialize;
window.runtime = runtime;
window.xa = xa;
